
import User from '@/models/User';
import Swal from 'sweetalert2';
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import Table from "@/components/solicitudes_beneficiario/Table.vue";
@Component({components:{Table}})
export default class Home extends Vue {
    @Getter('user') user: User;
    @Getter("isLoggedIn") isLoggedIn: boolean;
    public descriptionBeneficio: string = "";

    public redirectToRegistroFallecimiento() {
        this.$router.push("/consulta-afiliado-fallecido");
    }

    public redirectToIngresoTardio() {
        if (!this.user.esAfiliadoFallecido) {
            this.$router.push("/devolucion-ingreso-tardio");
        } else {
            Swal.fire({
                text: "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
                icon: "info"
            });
        }
    }

    public redirectToCesantia() {
        if (!this.user.esAfiliadoFallecido) {
            this.$router.push("/cesantia");
        } else {
            Swal.fire({
                text: "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
                icon: "info"
            });
        }
    } 

    public redirectToVejezAnticipada() {
        if (!this.user.esAfiliadoFallecido) {
            this.$router.push("/vejez-anticipada");
        } else {
            Swal.fire({
                text: "Llámanos a nuestros teléfonos 809-567-2371 o 1-809-200-2371 para obtener más información sobre procesar este beneficio.",
                icon: "info"
            });
        }
    }

    public onMouseEnter(obj: MouseEvent) {
        let eventTarget = obj.target as HTMLElement;
        let description = "";
        if (eventTarget.className.indexOf("menu-icon-option") > -1) {
            description = eventTarget.parentElement.dataset.description;
        } else {
            description = eventTarget.dataset.description;
        }

        this.descriptionBeneficio = description;
    }
    public onMouseLeave(obj) {
        this.descriptionBeneficio = "";
    }
}
